// import HomePage from "@/pages/home";
import DepositPage from "@/pages/deposit";
import WithdrawPage from "@/pages/withdraw";
import RegisterPage from "@/pages/register";
import WalletPage from "@/pages/wallet";
import LoginPage from "@/pages/login";
import AmountApply from "@/pages/amountApply";
import ResetAccountInfo from "@/pages/resetAccountInfo";
import AccountManager from "@/pages/accountManager";
import BindGA from "./pages/bindGA";
import HistoryBill from "@/pages/historyBill";
import User from "@/pages/mobileMenu/user";
// import Language from "@/pages/mobileMenu/lan";
import ForgetPage from "@/pages/fogetPwd";
// import CCExchangePage from "@/pages/ccExchange";
import Agreement from "@/pages/agreement";
import Privacypolicy from "@/pages/privacypolicy";
import Home from "@/pages/home";
import Transfer from "@/pages/transfer";
import Kyc from "@/pages/newKyc/kycAccount";
import CompanyKyc from "@/pages/newKyc/createCompanyAccount";
import PersonCertificate from "@/pages/newKyc/person/certificate";
import PersonCertificateBaseInfo from "@/pages/newKyc/person/baseInfo";
import PersonCertificateEvaluation from "@/pages/newKyc/person/evaluation";
import PersonCertificateVerify from "@/pages/newKyc/person/verify";
import OrderStatement from "@/pages/statement";
import WhiteAddress from "@/pages/whiteAddress";
import WhiteAddressAdd from "@/pages/whiteAddress/AddAddress";
// import VerifyTxAddress from "@/pages/verifyTxAddress";
import CompanyKycInfo from "@/pages/newKyc/company";
import LegalTender from "@/pages/legalTender";
import LegalTenderAdd from "@/pages/legalTender/legalTenderAdd";
import InfoPerodic from "@/pages/perodic";
import SubAccount from "@/pages/subAccount";
import SubAccountAdd from "@/pages/subAccount/AddAccount";
import SubAccountCreateApiKey from "@/pages/subAccount/AddApiKey/index";
import SubAccountTransfer from "@/pages/subAccount/AccountTransfer";
import SignCanvas from "@/pages/newKyc/person/baseInfo/AgreementSign";
import ClearOutUserWhiteAddressAdd from "@/pages/lagacyUser/whiteAddress/AddAddress";
import LegacyUser from "@/pages/lagacyUser";
import UpdateKycInfo from "@/pages/updateKycInfo";
import { useEffect, useState } from "react";
import { useAppSelector } from "@/state/hooks";

import {
  createBrowserRouter,
  // createHashRouter,
  ScrollRestoration,
  useRouteError,
  useLocation,
} from "react-router-dom";

import {
  BIXIN_WALLET,
  BIXIN_WALLET_DEPOSIT,
  BIXIN_WALLET_WITHDRAW,
  BIXIN_REGISTER,
  BIXIN_LOGIN,
  BIXIN_AMOUNTAPPLY,
  BIXIN_RESETACCOUNTINFO,
  BIXIN_ACCOUNTMANAGER,
  BIXIN_KYC,
  BIXIN_GA,
  BIXIN_WALLET_BILL,
  BIXIN_USERCENTER,
  BIXIN_FORGETPWD,
  // BIXIN_CC_EXCHANGE,
  BIXIN_AGREEMENT,
  BIXIN_PRIVACYPLICE,
  BIXIN_TRANSFER,
  BIXIN_COMPANY_KYC,
} from "@/helpers/constants/routeName";
import { getZendeskJwt } from "@/pages/bindGA/api";

const ErrorPage = () => {
  // useRouteError Hook 可以获取抛出的错误信息
  const error = useRouteError();
  console.log("ErrorPage", error);

  // 可以根据错误状态码显示不同的信息
  // if (error.status === 404) {
  //   // return <Notfund />;
  // } else if (error.status === 500) {
  //   // return <Error />;
  // } else if (error.message) {
  //   // return <Error />;
  // }

  return null;
};

const zeKey = "a6b01909-f813-4f1e-b1e6-17f5e566b4bc"; // prod

export const AppRoutes = () => {
  const element = [
    {
      path: "/",
      element: <Home />,
    },
    // {
    //   path: BIXIN_CC_EXCHANGE,
    //   element: <CCExchangePage />,
    // },
    {
      path: BIXIN_WALLET_BILL,
      element: <HistoryBill />,
    },
    {
      path: BIXIN_REGISTER,
      element: <RegisterPage />,
    },
    {
      path: BIXIN_LOGIN,
      element: <LoginPage />,
    },
    {
      path: BIXIN_FORGETPWD,
      element: <ForgetPage />,
    },

    {
      path: BIXIN_WALLET_WITHDRAW,
      element: <WithdrawPage />,
    },
    {
      path: BIXIN_WALLET_DEPOSIT,
      element: <DepositPage />,
    },
    {
      path: BIXIN_WALLET,
      element: <WalletPage />,
    },
    {
      path: BIXIN_AMOUNTAPPLY,
      element: <AmountApply />,
    },
    {
      path: BIXIN_RESETACCOUNTINFO,
      element: <ResetAccountInfo />,
    },
    {
      path: BIXIN_ACCOUNTMANAGER,
      element: <AccountManager />,
    },

    {
      path: BIXIN_GA,
      element: <BindGA />,
    },
    {
      path: BIXIN_USERCENTER,
      element: <User />,
    },
    {
      path: BIXIN_AGREEMENT,
      element: <Agreement />,
    },
    {
      path: BIXIN_PRIVACYPLICE,
      element: <Privacypolicy />,
    },
    {
      path: BIXIN_TRANSFER,
      element: <Transfer />,
    },
    {
      path: BIXIN_KYC,
      element: <Kyc />,
    },
    {
      path: BIXIN_COMPANY_KYC,
      element: <CompanyKyc />,
    },
    {
      path: "/trade/personKyc/certificate",
      element: <PersonCertificate />,
    },
    {
      path: "/trade/personKyc/baseInfo",
      element: <PersonCertificateBaseInfo />,
    },
    {
      path: "/trade/personKyc/evaluation",
      element: <PersonCertificateEvaluation />,
    },
    {
      path: "/trade/personKyc/verify",
      element: <PersonCertificateVerify />,
    },
    {
      path: "/trade/OrderStatement",
      element: <OrderStatement />,
    },
    {
      path: "/trade/whiteAddress",
      element: <WhiteAddress />,
    },
    {
      path: "/trade/whiteAddress/add",
      element: <WhiteAddressAdd />,
    },
    // {
    //   path: "/trade/verify/txAddress",
    //   element: <VerifyTxAddress />,
    // },
    {
      path: "/trade/companyKyc/info",
      element: <CompanyKycInfo />,
    },
    {
      path: "/trade/legal/tender",
      element: <LegalTender />,
    },
    {
      path: "/trade/legal/tender/add",
      element: <LegalTenderAdd />,
    },
    {
      path: "/trade/kycInfo/periodic", // 审阅
      element: <InfoPerodic />,
    },
    {
      path: "/trade/kycInfo/id-update", // 更新资料
      element: <UpdateKycInfo />,
    },
    {
      path: "/trade/subAccount",
      element: <SubAccount />,
    },
    {
      path: "/trade/subAccount/add",
      element: <SubAccountAdd />,
    },
    {
      path: "/trade/subAccount/add/apiKey",
      element: <SubAccountCreateApiKey />,
    },
    {
      path: "/trade/subAccount/transfer",
      element: <SubAccountTransfer />,
    },
    {
      path: "/trade/demo",
      element: <SignCanvas />,
    },
    {
      path: "/trade/offboard",
      element: <LegacyUser />,
    },
    // {
    //   path: "/trade/offboard/jumio", // 250617邮件清退用户
    //   element: <ClearOutUserJumio />,
    // },
    // {
    //   path: "/trade/offboard/whiteAddress", // 250617邮件清退用户
    //   element: <ClearOutUserWhiteAddress />,
    // },
    {
      path: "/trade/offboard/whiteAddress/add", // 250617邮件清退用户
      element: <ClearOutUserWhiteAddressAdd />,
    },
  ];

  return element;
};

const GlobalLayout = ({ children }) => {
  const userInfo = useAppSelector((state) => state.user.userInfo);

  const location = useLocation();

  const unloadZendesk = () => {
    // 移除Zendesk相关DOM元素
    const zendeskElements = document.querySelectorAll(
      '[data-testid="messenger"], #webWidget',
    );
    zendeskElements.forEach((el) => el.remove());

    // 移除script标签
    const script = document.getElementById("ze-snippet");
    if (script) script.remove();

    window.zendeskLoaded = false;
    window.zE = undefined;
  };

  useEffect(() => {
    const shouldLoad = location?.pathname?.includes("trade");

    if (!shouldLoad) {
      unloadZendesk();
      return;
    }

    if (shouldLoad) {
      const oldScript = document.getElementById("ze-snippet");
      if (oldScript) {
        oldScript.remove();
      }

      // 清理旧的DOM元素
      document
        .querySelectorAll(
          '[data-testid="messenger"], #webWidget, iframe[src*="zdassets"]',
        )
        .forEach((el) => el.remove());

      window.zendeskLoaded = false;
      window.zE = undefined;

      // 加载Zendesk
      const script = document.createElement("script");
      script.id = "ze-snippet";
      script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zeKey}`;
      script.onload = () => {
        window.zendeskLoaded = true;

        // 等待就绪后初始化
        const waitForReady = setInterval(() => {
          if (typeof window.zE === "function") {
            clearInterval(waitForReady);
            window.zE("messenger", "show");

            const token = localStorage.getItem("token");
            if (token && userInfo?.email) {
              // 有token：认证登录
              getZendeskJwt().then((res) => {
                if (res.data?.jwt_token) {
                  console.log("location.pathname location.pathname");
                  window.zE("messenger", "loginUser", (cb) =>
                    cb(res.data.jwt_token),
                  );
                  window.zE("messenger", "updateUser", {
                    name: `${userInfo.first_name || ""} ${userInfo.last_name || ""}`.trim(),
                    email: userInfo.email,
                  });
                }
              });
            } else {
              // 无token：匿名模式
              window.zE("messenger", "logoutUser");
            }
          }
        }, 100);
      };
      document.body.appendChild(script);
    } else if (!shouldLoad) {
      // 不需要加载时卸载
      document
        .querySelectorAll(
          '[data-testid="messenger"], #webWidget, iframe[src*="zdassets"]',
        )
        .forEach((el) => el.remove());
      const script = document.getElementById("ze-snippet");
      if (script) script.remove();
      window.zendeskLoaded = false;
      delete window.zE;
    }
  }, [location.pathname]);

  return <>{children}</>;
};
const createScrollRestore = (routes) =>
  routes.map(({ element, ...rest }) => ({
    ...rest,
    element: (
      <GlobalLayout>
        <ScrollRestoration />
        {element}
      </GlobalLayout>
    ),
    errorElement: <ErrorPage />,
  }));

export const router = createBrowserRouter(createScrollRestore(AppRoutes()));
